const LEARN_ADMIN = {
    OPTION_ENABLED: {
        event: 'learnAdminOptionEnabled',
        eventProperties: {
            description: 'Partner Admin enabled Learn Admin delegation option',
        },
    },
    CREATED: {
        event: 'learnAdminCreated',
        eventProperties: {
            description: 'Client Admin created a new Learn Admin user',
        },
    },
    ROLE_UPDATED: {
        event: 'learnAdminRoleUpdated',
        eventProperties: {
            description: 'User role changed to or from Learn Admin',
        },
    },
    DEACTIVATED: {
        event: 'learnAdminDeactivated',
        eventProperties: {
            description: 'Learn Admin user was deactivated',
        },
    },
};

export default LEARN_ADMIN;
